import {
    app,
    Component,
    payload,
    ojs,
    state,
    v,
    each,
} from "modular-openscriptjs";
import { dom, tool } from "../../../fotastart";
import {
    pageInfo,
    redirect,
    monetary,
    scrollToTop,
    either,
    isMobile,
    cleanDispose,
    consoleLogOnLocal,
    updateStateValue,
    consoleErrorOnLocal,
    inform,
    approved,
    eParse,
    getCommissionRatesForPrice,
    dataURLtoBlob,
    appendToFormData,
} from "../../../helpers";
import { PAGES, STRINGS, api, dc } from "../../../declarations";
import { $e } from "../../../ojs.events";
import { routes } from "../../../backendRoutes";
import SolidIcon from "../../Blocks/SolidIcon";
import OffcanvasBody from "../../Offcanvas/OffcanvasBody";
import ModalBody from "../../Modals/ModalBody";
import FormField from "../../Blocks/FormField";
import EditProductImageForm from "../../Forms/EditProductImageForm";
import Cropper from "cropperjs";
import Spinner, { SmallSpinner } from "../../Blocks/Spinner";

const h = app("h");
const broker = app("broker");
const router = app("router");

ojs(
    SolidIcon,
    OffcanvasBody,
    ModalBody,
    FormField,
    EditProductImageForm,
    SmallSpinner,
    Spinner,
);

export default class EditProduct extends Component {
    productId = null;
    product = state(null);
    loading = state(true);
    sellingPrice = state("");

    // Form Sections Toggle
    hasImages = state(false);
    hasAttributes = state(false);
    hasExtras = state(false);
    hasStockInfo = state(false);
    availableAtAllBranches = state(true);
    shouldEnhanceImages = state(false);

    features = state([]);
    extras = state([]);
    selectedBranches = state([]);

    formData = {
        name: "",
        sku: "",
        selling_price: "",
        quantity: "",
        processing_time: "",
        has_stock_information: false,
        short_description: "",
        branch_id: "",
        company_id: "",
        weight: 1,
        height: 1,
    };

    thumbnail = state(null);
    previewImages = state([]);
    deletedImages = []; // IDs of images to delete

    // Feature Form State
    editingFeatureIndex = state(-1);
    currentFeature = state(null);
    featureHolder = null;
    formHolder = null;

    // Product Search for Extras
    extraSearchQuery = state("");
    productSuggestions = state([]);
    loadingProductSuggestions = state(false);
    showProductSuggestions = state(false);
    productSearchTimeout = null;

    // Branches
    branches = state([]);
    loadingBranches = state(false);

    // Cropping
    cropper = { obj: null };

    $$product = {
        deleted: (ed) => {
            const { productId } = eParse(ed).message;

            if (productId == this.productId) {
                router.to("business.manage.inventory", {
                    companyId: this.formData.company_id,
                });
            }
        },
    };

    render() {
        this.productId = router.params.productId;
        if (!this.product.value && this.loading.value) {
            this.fetchProduct();
        }

        pageInfo("Edit Product");
        scrollToTop();

        return h.div(
            { class: "min-vh-100 py-5 mb-5 bg-light py-md-5" },
            h.div(
                { class: "container" },
                h.div(
                    { class: "row justify-content-center" },
                    h.div(
                        { class: "col-lg-10 col-xl-8" },

                        // Header
                        h.div(
                            {
                                class: "d-flex align-items-center justify-content-between mb-5",
                            },
                            h.div(
                                { class: "d-flex align-items-center gap-3" },
                                h.button(
                                    {
                                        class: "btn btn-white border shadow-sm rounded-circle p-2",
                                        listeners: {
                                            click: () => history.back(),
                                        },
                                    },
                                    h.SolidIcon("arrow-left"),
                                ),
                                h.div(
                                    h.h2(
                                        { class: "fw-bold mb-0" },
                                        "Edit Product",
                                    ),
                                    v(this.product, (p) =>
                                        p.value
                                            ? h.p(
                                                  { class: "text-muted mb-0" },
                                                  p.value.name,
                                              )
                                            : null,
                                    ),
                                ),
                            ),
                            h.button(
                                {
                                    class: "btn btn-outline-danger border-0 rounded-pill fw-bold d-flex gap-1 align-items-center",
                                    listeners: {
                                        click: () => this.confirmDelete(),
                                    },
                                },
                                h.i({ class: "bi bi-trash me-2" }),
                                h.span(
                                    { class: "d-none d-md-block" },
                                    "Delete Product",
                                ),
                            ),
                        ),

                        v(this.loading, (loading) => {
                            if (loading.value)
                                return h.div(
                                    { class: "text-center py-5" },
                                    h.Spinner(),
                                );

                            return h.div(
                                { class: "row g-4 animate-step" },
                                this.renderDashboardCard(
                                    "Basic Information",
                                    "Name, price, SKU, and description.",
                                    "info-circle",
                                    "primary",
                                    () => this.openEditForm("basic"),
                                ),
                                this.renderDashboardCard(
                                    "Product Visuals",
                                    "Update thumbnail and gallery images.",
                                    "image",
                                    "success",
                                    () => this.openEditForm("images"),
                                ),
                                this.renderDashboardCard(
                                    "Attributes & Variations",
                                    "Sizes, colors, and custom inputs.",
                                    "list-stars",
                                    "warning",
                                    () => this.openEditForm("attributes"),
                                ),
                                this.renderDashboardCard(
                                    "Extras & Accessories",
                                    "Optional products customers can add.",
                                    "plus-square",
                                    "info",
                                    () => this.openEditForm("extras"),
                                ),
                                this.renderDashboardCard(
                                    "Branch Availability",
                                    "Where this product can be bought.",
                                    "geo-alt",
                                    "danger",
                                    () => this.openEditForm("availability"),
                                ),
                                this.renderDashboardCard(
                                    "Stock Information",
                                    "Track stock quantity and add new stock.",
                                    "box-seam",
                                    "secondary",
                                    () => this.openEditForm("stock"),
                                ),
                            );
                        }),
                    ),
                ),
            ),
        );
    }

    renderDashboardCard(title, description, icon, color, onclick) {
        return h.div(
            { class: "col-12 col-md-6", role: "button" },
            h.div(
                {
                    class: "card border-0 shadow-sm h-100 cursor-pointer hover-shadow transition-all overflow-hidden",
                    style: "border-radius: 24px;",
                    listeners: { click: onclick },
                },
                h.div(
                    { class: "card-body p-4 d-flex align-items-start gap-4" },
                    h.div(
                        {
                            class: `bg-${color}-subtle text-${color} rounded-4 p-3 d-flex align-items-center justify-content-center`,
                            style: "width: 60px; height: 60px;",
                        },
                        h.i({ class: `bi bi-${icon} fs-2` }),
                    ),
                    h.div(
                        { class: "flex-fill" },
                        h.h5({ class: "fw-bold mb-2" }, title),
                        h.p({ class: "text-muted mb-0 small" }, description),
                    ),
                    h.i({ class: "bi bi-chevron-right text-muted mt-2" }),
                ),
            ),
        );
    }

    async fetchProduct() {
        this.loading.value = true;
        try {
            const res = await api.get(`products/${this.productId}`);
            if (res) {
                const p = res.data.product;
                this.product.value = p;

                // Initialize form data
                this.formData.name = p.name;
                this.formData.sku = p.sku;
                this.formData.selling_price = p.selling_price;
                this.sellingPrice.value = p.selling_price;
                this.formData.quantity = p.quantity;
                this.formData.processing_time = p.processing_time;
                this.formData.short_description = p.short_description;
                this.formData.company_id = p.company_id;
                this.formData.weight = p.weight || 0;
                this.formData.height = p.height || 0;
                this.formData.has_stock_information = p.has_stock_information;

                this.hasStockInfo.value = p.has_stock_information;
                this.hasAttributes.value = p.features.length > 0;
                this.features.value = p.features.map((f) => ({
                    ...f,
                    values:
                        f.values.length > 0
                            ? f.values
                            : [{ value: f.value_label, price: 0 }],
                }));

                this.hasExtras.value = p.extras.length > 0;
                this.extras.value = p.extras.map((e) => ({
                    buyable_id: e.buyable_id,
                    buyable_type: e.buyable_type,
                    quantity: e.quantity,
                    name: e.name || e.buyable?.name,
                    price: e.price || e.buyable?.selling_price,
                    thumbnail_path: e.buyable?.thumbnail_path,
                }));

                this.availableAtAllBranches.value = p.available_at_all_branches;
                this.selectedBranches.value = p.branches.map((b) => b.id);
                this.shouldEnhanceImages.value = p.should_enhance_images;

                // Images
                this.thumbnail.value = p.thumbnail_path
                    ? { cropped: p.thumbnail_path, isExisting: true }
                    : null;
                this.previewImages.value = p.images
                    .filter((img) => img.path !== p.thumbnail_path)
                    .map((img) => ({
                        id: img.id,
                        cropped: img.path,
                        isExisting: true,
                    }));
            } else {
                router.to("business.manage.inventory", {
                    companyId: router.params.companyId,
                });
            }
        } catch (e) {
            consoleErrorOnLocal(e);
            inform("Could not load product details.", STRINGS.ERROR);
        } finally {
            this.loading.value = false;
        }
    }

    openEditForm(section) {
        if (this.formHolder) cleanDispose(this.formHolder);

        const formMap = {
            basic: () => this.renderBasicInfoForm(),
            images: () => this.renderImagesForm(),
            attributes: () => this.renderAttributesForm(),
            extras: () => this.renderExtrasForm(),
            availability: () => this.renderAvailabilityForm(),
            stock: () => this.renderStockForm(),
        };

        const titles = {
            basic: "Edit Basic Information",
            images: "Update Product Visuals",
            attributes: "Manage Attributes",
            extras: "Optional Extras",
            availability: "Branch Availability",
            stock: "Manage Stock & Inventory",
        };

        const form = formMap[section]();
        const content = h.div(
            { class: "p-3" },
            h.div(
                {
                    class: "d-flex justify-content-between align-items-center mb-4",
                },
                h.h4({ class: "fw-bold mb-0" }, titles[section]),
                h.button({
                    class: "btn-close",
                    listeners: { click: () => this.formHolder.hide() },
                }),
            ),
            form,
        );

        if (isMobile()) {
            this.formHolder = tool.offcanvas(h.OffcanvasBody(content), {
                class: "rounded-top-5 min-vh-75",
            });
        } else {
            this.formHolder = tool.plainModal(h.ModalBody(content), {
                class: "modal-lg",
            });
        }

        this.formHolder.show();
    }

    // --- SECTION FORMS ---

    renderBasicInfoForm() {
        return h.div(
            {},
            this.renderInput("name", "Product Name", "e.g. White Chapati"),
            h.div(
                { class: "mb-4" },
                h.label(
                    { class: "form-label fw-bold mb-1" },
                    `Base Price (${dc.userCurrency})`,
                ),
                h.input({
                    class: "form-control bg-light border p-3 rounded-3",
                    type: "number",
                    value: this.sellingPrice.value,
                    listeners: {
                        input: (e) => {
                            this.formData.selling_price = e.target.value;
                            this.sellingPrice.value = e.target.value;
                        },
                    },
                    placeholder: "0.00",
                }),
                h.small(
                    { class: "text-muted mt-1 d-block" },
                    "The base price of this item before adjustments.",
                ),
            ),

            v(this.sellingPrice, (priceState) => {
                const basePrice = parseFloat(priceState.value) || 0;
                if (basePrice <= 0) return null;

                const { customerRate, businessRate } =
                    getCommissionRatesForPrice(basePrice);
                const finalPrice =
                    basePrice + Math.ceil((basePrice * customerRate) / 100);
                const payout =
                    basePrice - Math.ceil((basePrice * businessRate) / 100);

                return h.div(
                    {
                        class: "row g-3 mb-4 animate-step flex-nowrap overflow-x-auto pb-2 flex-md-wrap",
                    },
                    // Customer Card: Final Adjusted Price
                    h.div(
                        { class: "col-10 col-md-6 flex-shrink-0" },
                        h.div(
                            {
                                class: "card border-0 shadow-sm p-3 text-center h-100",
                                style: "border-radius: 16px;",
                            },
                            h.i({
                                class: "bi bi-person-fill text-warning fs-3 mb-1",
                            }),
                            h.div(
                                { class: "text-muted small fw-semibold" },
                                "Final Adjusted Price",
                            ),
                            h.div(
                                {
                                    class: "small text-muted mb-2",
                                    style: "font-size: 0.75rem;",
                                },
                                "Price customers will see",
                            ),
                            h.div(
                                { class: "fw-bold fs-4 text-dark mb-1" },
                                monetary(finalPrice, dc.userCurrency),
                            ),
                            h.span(
                                {
                                    class: "bg-warning-subtle text-warning-emphasis rounded-pill px-2 py-1 fs-xsm rounded",
                                },
                                `+${customerRate}% Price Markup`,
                            ),
                        ),
                    ),
                    // Business Card: Receive after Carata Commission
                    h.div(
                        { class: "col-10 col-md-6 flex-shrink-0" },
                        h.div(
                            {
                                class: "card border-0 shadow-sm p-3 text-center h-100",
                                style: "border-radius: 16px;",
                            },
                            h.i({
                                class: "bi bi-briefcase-fill text-primary fs-3 mb-1",
                            }),
                            h.div(
                                { class: "text-muted small fw-semibold" },
                                "You'll Receive",
                            ),
                            h.div(
                                {
                                    class: "small text-muted mb-2",
                                    style: "font-size: 0.75rem;",
                                },
                                "Amount you'll receive on Purchase",
                            ),
                            h.div(
                                { class: "fw-bold fs-4 text-dark mb-1" },
                                monetary(payout, dc.userCurrency),
                            ),
                            h.span(
                                {
                                    class: "bg-primary-subtle text-primary-emphasis rounded-pill px-2 py-1 fs-xsm rounded",
                                },
                                `-${businessRate}% Carata Commission`,
                            ),
                        ),
                    ),
                );
            }),
            this.renderSelect(
                "processing_time",
                "Processing Time (Minutes)",
                Array.from({ length: 12 }, (_, i) => {
                    const val = (i + 1) * 5;
                    return { value: val, label: val + " mins" };
                }),
                "Estimated time to prepare this product (optional).",
            ),
            this.renderTextarea(
                "short_description",
                "Short Description",
                "Key features...",
            ),

            h.div(
                {
                    class: "form-check form-switch mb-4 d-flex align-items-center gap-2",
                },
                h.input(
                    {
                        class: "form-check-input mt-0",
                        type: "checkbox",
                        role: "switch",
                        id: "edit-stock-toggle",
                        listeners: {
                            change: (e) => {
                                this.hasStockInfo.value = e.target.checked;
                                this.formData.has_stock_information =
                                    e.target.checked;
                            },
                        },
                    },
                    either(this.hasStockInfo.value, { checked: true }),
                ),
                h.label(
                    {
                        class: "form-check-label small fw-bold text-muted text-uppercase",
                        for: "edit-stock-toggle",
                    },
                    "Track Stock & SKU",
                ),
            ),

            v(this.hasStockInfo, (has) => {
                if (!has.value) return null;
                return h.div(
                    { class: "row g-3 mb-4" },
                    h.div(
                        { class: "col-6" },
                        this.renderInput("quantity", "Stock", "10", "number"),
                    ),
                    h.div(
                        { class: "col-6" },
                        this.renderInput("sku", "SKU", "SKU-123"),
                    ),
                );
            }),

            h.button(
                {
                    class: "btn btn-primary w-100 rounded-pill py-3 fw-bold mt-4",
                    id: `save-basic-${this.productId}`,
                    listeners: { click: (e) => this.saveBasicInfo(e.target) },
                },
                "Save Changes",
            ),
        );
    }

    renderImagesForm() {
        return h.div(
            {},
            h.div(
                { class: "mb-4" },
                h.label(
                    {
                        class: "form-label fw-bold small text-muted text-uppercase",
                    },
                    "Main Photo",
                ),
                v(this.thumbnail, (thumb) =>
                    h.div(
                        {
                            class: "position-relative border-2 border-dashed rounded-4 overflow-hidden text-center cursor-pointer p-2",
                            style: "min-height: 150px; display: flex; align-items: center; justify-content: center;",
                            listeners: {
                                click: () =>
                                    this.triggerUpload("edit-thumb-input"),
                            },
                        },
                        thumb.value
                            ? [
                                  h.img({
                                      src: thumb.value.cropped.startsWith(
                                          "http",
                                      )
                                          ? thumb.value.cropped
                                          : thumb.value.cropped,
                                      class: "img-fluid rounded-3",
                                      style: "max-height: 140px;",
                                  }),
                                  h.button(
                                      {
                                          class: "btn btn-danger btn-sm rounded-circle position-absolute",
                                          style: "top: 0px; right: 24px;",
                                          listeners: {
                                              click: (e) => {
                                                  e.stopPropagation();
                                                  this.thumbnail.value = null;
                                              },
                                          },
                                      },
                                      h.i({ class: "bi bi-x-lg" }),
                                  ),
                              ]
                            : h.div(
                                  {},
                                  h.i({
                                      class: "bi bi-camera fs-2 text-muted",
                                  }),
                                  h.p(
                                      { class: "small text-muted mb-0" },
                                      "Add main photo",
                                  ),
                              ),
                    ),
                ),
                h.input({
                    type: "file",
                    id: "edit-thumb-input",
                    class: "d-none",
                    accept: "image/*",
                    listeners: {
                        change: (e) => this.handleImageUpload(e, "thumbnail"),
                    },
                }),
            ),

            h.div(
                { class: "mb-4" },
                h.label(
                    {
                        class: "form-label fw-bold small text-muted text-uppercase",
                    },
                    "Gallery",
                ),
                h.div(
                    { class: "row g-2" },
                    v(this.previewImages, (imgs) => [
                        ...imgs.value.map((img, i) =>
                            h.div(
                                { class: "col-3" },
                                h.div(
                                    {
                                        class: "position-relative border rounded-3 overflow-hidden bg-light",
                                        style: "padding-top: 100%;",
                                    },
                                    h.img({
                                        src: img.cropped,
                                        class: "position-absolute top-0 start-0 w-100 h-100",
                                        style: "object-fit: cover;",
                                    }),
                                    h.button(
                                        {
                                            class: "btn btn-danger btn-xs rounded-circle position-absolute",
                                            style: "top: 5px; right: 5px; padding: 0 4px;",
                                            listeners: {
                                                click: () => {
                                                    if (img.isExisting)
                                                        this.deletedImages.push(
                                                            img.id,
                                                        );
                                                    updateStateValue(
                                                        this.previewImages,
                                                        (v) => {
                                                            v.splice(i, 1);
                                                            return v;
                                                        },
                                                    );
                                                },
                                            },
                                        },
                                        h.i({
                                            class: "bi bi-x-lg",
                                            style: "font-size: 10px;",
                                        }),
                                    ),
                                ),
                            ),
                        ),
                        h.div(
                            { class: "col-3" },
                            h.div(
                                {
                                    class: "border-2 border-dashed rounded-3 d-flex align-items-center justify-content-center cursor-pointer",
                                    style: "padding-top: 100%; position: relative;",
                                    listeners: {
                                        click: () =>
                                            this.triggerUpload(
                                                "edit-gallery-input",
                                            ),
                                    },
                                },
                                h.i({
                                    class: "bi bi-plus fs-2 text-muted position-absolute top-50 start-50 translate-middle",
                                }),
                            ),
                        ),
                    ]),
                ),
                h.input({
                    type: "file",
                    id: "edit-gallery-input",
                    class: "d-none",
                    accept: "image/*",
                    multiple: true,
                    listeners: {
                        change: (e) => this.handleImageUpload(e, "gallery"),
                    },
                }),
            ),

            h.div(
                {
                    class: "form-check form-switch mb-5 d-flex align-items-center gap-2",
                },
                h.input(
                    {
                        class: "form-check-input mt-0",
                        type: "checkbox",
                        role: "switch",
                        id: "edit-enhance-toggle",
                        listeners: {
                            change: (e) =>
                                (this.shouldEnhanceImages.value =
                                    e.target.checked),
                        },
                    },
                    either(this.shouldEnhanceImages.value, { checked: true }),
                ),
                h.label(
                    {
                        class: "form-check-label small fw-bold text-muted text-uppercase",
                        for: "edit-enhance-toggle",
                    },
                    "Enhance Images? (AI)",
                ),
                h.small(
                    { class: "text-muted d-block ms-auto" },
                    "Background removal",
                ),
            ),

            h.button(
                {
                    class: "btn btn-success w-100 rounded-pill py-3 fw-bold mt-2",
                    id: `save-images-${this.productId}`,
                    listeners: { click: (e) => this.saveImages(e.target) },
                },
                "Update Visuals",
            ),
        );
    }

    renderAttributesForm() {
        return h.div(
            {},
            v(this.features, (features) =>
                h.div(
                    { class: "d-grid gap-3 mb-4" },
                    features.value.length === 0
                        ? h.div(
                              {
                                  class: "p-4 bg-light rounded-4 text-center text-muted border-dashed small",
                              },
                              "No attributes defined.",
                          )
                        : features.value.map((f, i) =>
                              this.renderFeatureItem(f, i),
                          ),
                ),
            ),
            h.button(
                {
                    class: "btn btn-outline-primary w-100 rounded-pill mb-4 py-2",
                    listeners: { click: () => this.openFeatureForm() },
                },
                h.i({ class: "bi bi-plus-lg me-2" }),
                "Add New Attribute",
            ),
            h.button(
                {
                    class: "btn btn-primary w-100 rounded-pill py-3 fw-bold",
                    id: `save-attrs-${this.productId}`,
                    listeners: { click: (e) => this.saveAttributes(e.target) },
                },
                "Save Attributes",
            ),
        );
    }

    renderExtrasForm() {
        return h.div(
            {},
            h.div(
                { class: "mb-4 position-relative" },
                h.label(
                    {
                        class: "form-label fw-bold small text-muted text-uppercase",
                    },
                    "Add Product as Extra",
                ),
                h.input({
                    class: "form-control bg-light border p-3 rounded-3",
                    placeholder: "Search products...",
                    id: "edit-extra-search",
                    listeners: {
                        input: (e) => this.handleProductSearch(e),
                        focus: () => {
                            if (this.productSuggestions.value.length > 0)
                                this.showProductSuggestions.value = true;
                        },
                    },
                }),
                v(this.showProductSuggestions, (show) => {
                    if (!show.value) return null;
                    return h.div(
                        {
                            class: "position-absolute w-100 bg-white shadow rounded-4 mt-2 overflow-hidden border",
                            style: "z-index: 1000;",
                        },
                        v(this.loadingProductSuggestions, (loading) => {
                            if (loading.value)
                                return h.div(
                                    { class: "p-3 text-center" },
                                    h.SmallSpinner(),
                                );
                            return v(this.productSuggestions, (sugs) => {
                                if (sugs.value.length === 0)
                                    return h.div(
                                        { class: "p-3 text-muted small" },
                                        "No products found.",
                                    );
                                return h.div(
                                    { class: "list-group list-group-flush" },
                                    ...sugs.value.map((prod) =>
                                        h.button(
                                            {
                                                class: "list-group-item list-group-item-action d-flex align-items-center gap-2 py-2 px-3 border-0",
                                                onclick: this.method(
                                                    "addExtraProduct",
                                                    [
                                                        prod,
                                                        "${dom.id('edit-extra-search')}",
                                                    ],
                                                ),
                                            },
                                            h.img({
                                                src:
                                                    prod.thumbnail_path ||
                                                    "/assets/images/product-placeholder.png",
                                                class: "rounded",
                                                style: "width: 30px; height: 30px; object-fit: cover;",
                                            }),
                                            h.div(
                                                { class: "small fw-bold" },
                                                prod.name,
                                            ),
                                        ),
                                    ),
                                );
                            });
                        }),
                    );
                }),
            ),

            v(this.extras, (extras) =>
                h.div(
                    { class: "d-grid gap-3 mb-4" },
                    extras.value.length === 0
                        ? h.div(
                              {
                                  class: "p-4 bg-light rounded-4 text-center text-muted border-dashed small",
                              },
                              "Search and add extras.",
                          )
                        : extras.value.map((e, i) =>
                              this.renderExtraItem(e, i),
                          ),
                ),
            ),

            h.button(
                {
                    class: "btn btn-primary w-100 rounded-pill py-3 fw-bold",
                    id: `save-extras-${this.productId}`,
                    listeners: { click: (e) => this.saveExtras(e.target) },
                },
                "Save Extras",
            ),
        );
    }

    renderAvailabilityForm() {
        if (this.branches.value.length === 0 && !this.loadingBranches.value) {
            this.fetchBranches();
        }

        return h.div(
            {},
            h.div(
                { class: "mb-4 border rounded-4 p-3 bg-light" },
                this.renderToggleQuestion(
                    "availableAtAllBranches",
                    "Available at all branches?",
                    "Listed in all your shop locations.",
                ),
            ),

            v(this.availableAtAllBranches, (all) => {
                if (all.value) return null;

                return v(this.loadingBranches, (loading) => {
                    if (loading.value)
                        return h.div(
                            { class: "text-center py-4" },
                            h.SmallSpinner(),
                        );
                    return v(this.branches, (branches) =>
                        v(this.selectedBranches, (selectedBranches) =>
                            h.div(
                                { class: "d-grid gap-2 mb-4" },
                                ...branches.value.map((branch) => {
                                    const isSelected =
                                        selectedBranches.value.includes(
                                            branch.id,
                                        );
                                    return h.div(
                                        {
                                            class: `d-flex align-items-center gap-3 p-3 rounded-4 border-2 cursor-pointer transition-all ${
                                                isSelected
                                                    ? "border-primary bg-primary-subtle bg-opacity-10"
                                                    : "border-transparent bg-white shadow-sm"
                                            }`,
                                            listeners: {
                                                click: () =>
                                                    this.toggleBranch(
                                                        branch.id,
                                                    ),
                                            },
                                        },
                                        h.div(
                                            {
                                                class: `rounded-circle border d-flex align-items-center justify-content-center ${
                                                    isSelected
                                                        ? "bg-primary border-primary text-white"
                                                        : "bg-white"
                                                }`,
                                                style: "width: 20px; height: 20px;",
                                            },
                                            isSelected
                                                ? h.i({ class: "bi bi-check" })
                                                : null,
                                        ),
                                        h.div(
                                            h.div(
                                                { class: "fw-bold small" },
                                                branch.name,
                                            ),
                                            h.div(
                                                { class: "text-muted smaller" },
                                                branch.readable_address,
                                            ),
                                        ),
                                    );
                                }),
                            ),
                        ),
                    );
                });
            }),

            h.button(
                {
                    class: "btn btn-primary w-100 rounded-pill py-3 fw-bold mt-2",
                    id: `save-availability-${this.productId}`,
                    listeners: {
                        click: (e) => this.saveAvailability(e.target),
                    },
                },
                "Update Availability",
            ),
        );
    }

    // --- REUSED UI COMPONENTS ---

    renderInput(name, label, placeholder, type = "text") {
        return h.div(
            { class: "mb-3" },
            h.label(
                {
                    class: "form-label fw-bold small text-muted text-uppercase mb-1",
                },
                label,
            ),
            h.input({
                class: "form-control bg-light border p-3 rounded-3",
                type: type,
                value: this.formData[name] ?? "",
                listeners: {
                    input: (e) => (this.formData[name] = e.target.value),
                },
                placeholder: placeholder,
            }),
        );
    }

    renderSelect(name, label, options, help = "") {
        return h.div(
            { class: "mb-3" },
            h.label(
                {
                    class: "form-label fw-bold small text-muted text-uppercase mb-1",
                },
                label,
            ),
            h.select(
                {
                    class: "form-select bg-light border p-3 rounded-3",
                    listeners: {
                        change: (e) => (this.formData[name] = e.target.value),
                    },
                },
                h.option({ value: "" }, "Select..."),
                ...options.map((opt) =>
                    h.option(
                        {
                            value: opt.value,
                            selected: this.formData[name] == opt.value,
                        },
                        opt.label,
                    ),
                ),
            ),
            help ? h.small({ class: "text-muted mt-1 d-block" }, help) : null,
        );
    }

    renderTextarea(name, label, placeholder) {
        return h.div(
            { class: "mb-3" },
            h.label(
                {
                    class: "form-label fw-bold small text-muted text-uppercase mb-1",
                },
                label,
            ),
            h.textarea(
                {
                    class: "form-control bg-light border p-3 rounded-3",
                    rows: 3,
                    listeners: {
                        input: (e) => (this.formData[name] = e.target.value),
                    },
                    placeholder: placeholder,
                },
                this.formData[name],
            ),
        );
    }

    renderToggleQuestion(stateKey, question, help) {
        return h.div(
            {
                class: "d-flex justify-content-between align-items-center gap-3 py-1",
            },
            h.div(
                { class: "flex-fill" },
                h.h6({ class: "fw-bold mb-0 small" }, question),
                h.p({ class: "text-muted smaller mb-0" }, help),
            ),
            h.div(
                { class: "btn-group p-1 bg-white rounded-pill border" },
                v(this[stateKey], (val) =>
                    h.button(
                        {
                            class: `btn btn-xs rounded-pill py-1 px-3 fw-bold ${
                                !val.value
                                    ? "bg-danger text-white"
                                    : "bg-transparent text-muted border-0"
                            }`,
                            listeners: {
                                click: () => (this[stateKey].value = false),
                            },
                        },
                        "No",
                    ),
                ),
                v(this[stateKey], (val) =>
                    h.button(
                        {
                            class: `btn btn-xs rounded-pill py-1 px-3 fw-bold ${
                                val.value
                                    ? "bg-success text-white"
                                    : "bg-transparent text-muted border-0"
                            }`,
                            listeners: {
                                click: () => (this[stateKey].value = true),
                            },
                        },
                        "Yes",
                    ),
                ),
            ),
        );
    }

    // --- FORM LOGIC & SAVE METHODS ---

    renderStockForm() {
        return h.div(
            {},
            h.div(
                {
                    class: "form-check form-switch mb-4 d-flex align-items-center gap-2",
                },
                h.input(
                    {
                        class: "form-check-input mt-0",
                        type: "checkbox",
                        role: "switch",
                        id: "edit-stock-info-toggle",
                        listeners: {
                            change: (e) => {
                                this.hasStockInfo.value = e.target.checked;
                                this.formData.has_stock_information = e.target.checked;
                            },
                        },
                    },
                    either(this.hasStockInfo.value, { checked: true }),
                ),
                h.label(
                    {
                        class: "form-check-label small fw-bold text-muted text-uppercase",
                        for: "edit-stock-info-toggle",
                    },
                    "Track Stock Information",
                ),
            ),

            v(this.hasStockInfo, (has) => {
                if (!has.value) return null;
                const currentQty = this.product.value?.quantity || 0;
                return h.div(
                    { class: "animate-step" },
                    h.div(
                        { class: "mb-3 p-3 bg-light rounded-3 d-flex justify-content-between align-items-center" },
                        h.span({ class: "fw-bold text-muted" }, "Current Quantity:"),
                        h.span({ class: "fs-5 fw-bold text-dark" }, currentQty)
                    ),
                    h.div(
                        { class: "mb-4" },
                        h.label({ class: "form-label fw-bold mb-1" }, "Add Stock Quantity"),
                        h.input({
                            class: "form-control bg-light border p-3 rounded-3",
                            type: "number",
                            id: "stock-quantity-to-add",
                            placeholder: "e.g. 10",
                            min: "0"
                        }),
                        h.small(
                            { class: "text-muted mt-1 d-block" },
                            "Specify the quantity to add to the existing stock.",
                        )
                    )
                );
            }),

            h.button(
                {
                    class: "btn btn-primary w-100 rounded-pill py-3 fw-bold mt-4",
                    id: `save-stock-${this.productId}`,
                    listeners: { click: (e) => this.saveStock(e.target) },
                },
                "Save Changes",
            ),
        );
    }

    async saveStock(btn) {
        dom.disable(btn);
        h.SmallSpinner({ parent: btn, resetParent: true });

        const qtyToAddInput = document.getElementById("stock-quantity-to-add");
        const qtyToAdd = qtyToAddInput ? parseInt(qtyToAddInput.value, 10) : 0;

        try {
            const res = await api.put(
                routes.productStock(this.productId),
                {
                    has_stock_information: this.hasStockInfo.value,
                    quantity: qtyToAdd > 0 ? qtyToAdd : 0
                }
            );
            if (res) {
                inform("Stock information updated!", STRINGS.SUCCESS);
                this.product.value = res.data.product;
                this.formData.quantity = res.data.product.quantity;
                this.formHolder.hide();
            }
        } catch (e) {
            inform("Failed to update stock.", STRINGS.ERROR);
        } finally {
            dom.enable(btn);
            h.span("Save Changes", { parent: btn, resetParent: true });
        }
    }

    async saveBasicInfo(btn) {
        dom.disable(btn);
        h.SmallSpinner({ parent: btn, resetParent: true });

        try {
            const res = await api.put(
                routes.productBasicInfo(this.productId),
                this.formData,
            );
            if (res) {
                inform("Basic information updated!", STRINGS.SUCCESS);
                this.product.value = res.data.product;
                this.formHolder.hide();
            }
        } catch (e) {
            inform("Failed to update information.", STRINGS.ERROR);
        } finally {
            dom.enable(btn);
            h.span("Save Changes", { parent: btn, resetParent: true });
        }
    }

    async saveImages(btn) {
        dom.disable(btn);
        h.SmallSpinner({ parent: btn, resetParent: true });

        try {
            const formData = new FormData();
            formData.append("_method", "PUT");

            if (this.thumbnail.value && !this.thumbnail.value.isExisting) {
                const thumbBlobObj = {
                    original: await dataURLtoBlob(
                        this.thumbnail.value.original,
                    ),
                    cropped: await dataURLtoBlob(this.thumbnail.value.cropped),
                    cropData: this.thumbnail.value.cropData,
                };
                appendToFormData(formData, thumbBlobObj, "thumbnail");
            } else if (this.thumbnail.value) {
                formData.append("thumbnail", this.thumbnail.value.cropped);
            } else {
                formData.append("thumbnail", "");
            }

            const newGalleryImgs = this.previewImages.value.filter(
                (img) => !img.isExisting,
            );
            const galleryBlobs = [];
            for (const img of newGalleryImgs) {
                galleryBlobs.push({
                    original: await dataURLtoBlob(img.original),
                    cropped: await dataURLtoBlob(img.cropped),
                    cropData: img.cropData,
                });
            }

            appendToFormData(formData, galleryBlobs, "gallery");
            appendToFormData(formData, this.deletedImages, "deleted_images");
            appendToFormData(
                formData,
                this.shouldEnhanceImages.value,
                "should_enhance_images",
            );

            const res = await api.post(
                routes.productImages(this.productId),
                formData,
                {
                    fetch_using: "browser",
                    "remove-content-type": true,
                },
            );

            if (res) {
                inform("Visuals updated successfully!", STRINGS.SUCCESS);
                this.product.value = res.data.product;
                this.deletedImages = [];
                // Re-init images
                const p = res.data.product;
                this.thumbnail.value = p.thumbnail_path
                    ? { cropped: p.thumbnail_path, isExisting: true }
                    : null;
                this.previewImages.value = p.images
                    .filter((img) => img.path !== p.thumbnail_path)
                    .map((img) => ({
                        id: img.id,
                        cropped: img.path,
                        isExisting: true,
                    }));

                this.formHolder.hide();
            }
        } catch (e) {
            inform("Failed to update visuals.", STRINGS.ERROR);
        } finally {
            dom.enable(btn);
            h.span("Update Visuals", { parent: btn, resetParent: true });
        }
    }

    async saveAttributes(btn) {
        dom.disable(btn);
        h.SmallSpinner({ parent: btn, resetParent: true });

        try {
            const res = await api.put(
                routes.productAttributes(this.productId),
                {
                    features: this.features.value,
                },
            );
            if (res) {
                inform("Attributes updated!", STRINGS.SUCCESS);
                this.product.value = res.data.product;
                this.formHolder.hide();
            }
        } catch (e) {
            inform("Failed to update attributes.", STRINGS.ERROR);
        } finally {
            dom.enable(btn);
            h.span("Save Attributes", { parent: btn, resetParent: true });
        }
    }

    async saveExtras(btn) {
        dom.disable(btn);
        h.SmallSpinner({ parent: btn, resetParent: true });

        try {
            const res = await api.put(routes.productExtras(this.productId), {
                extras: this.extras.value,
            });
            if (res) {
                inform("Extras updated!", STRINGS.SUCCESS);
                this.product.value = res.data.product;
                this.formHolder.hide();
            }
        } catch (e) {
            inform("Failed to update extras.", STRINGS.ERROR);
        } finally {
            dom.enable(btn);
            h.span("Save Extras", { parent: btn, resetParent: true });
        }
    }

    async saveAvailability(btn) {
        dom.disable(btn);
        h.SmallSpinner({ parent: btn, resetParent: true });

        const data = {
            available_at_all_branches: this.availableAtAllBranches.value,
            branches: this.availableAtAllBranches.value
                ? []
                : this.selectedBranches.value,
        };

        try {
            const res = await api.put(
                routes.productAvailability(this.productId),
                data,
            );
            if (res) {
                inform("Availability updated!", STRINGS.SUCCESS);
                this.product.value = res.data.product;
                this.formHolder.hide();
            }
        } catch (e) {
            inform("Failed to update availability.", STRINGS.ERROR);
        } finally {
            dom.enable(btn);
            h.span("Update Availability", { parent: btn, resetParent: true });
        }
    }

    async confirmDelete() {
        broker.send($e.product.needs.deletion, payload({ id: this.productId }));
    }

    // --- SHARED REUSED LOGIC FROM ADDPRODUCT ---

    openFeatureForm(index = -1) {
        if (this.featureHolder) {
            cleanDispose(this.featureHolder);
        }

        let feature = this.features.value[index] ?? null;

        this.editingFeatureIndex.value = index;
        this.currentFeature.value = feature
            ? tool.deepCopy(feature)
            : {
                  name: "",
                  choice_type: "single_choice",
                  is_required: true,
                  has_different_prices: false,
                  values: [{ value: "", price: "" }],
                  price_interval: "",
                  price_per_interval: "",
              };

        const form = () => this.renderFeatureForm();

        if (isMobile()) {
            this.featureHolder = tool.offcanvas(h.OffcanvasBody(form()), {
                class: "rounded-top-5",
            });
        } else {
            this.featureHolder = tool.plainModal(h.ModalBody(form()));
        }

        this.featureHolder.show();
    }

    renderFeatureForm() {
        return h.div(
            { class: "p-2" },
            h.div(
                {
                    class: "d-flex justify-content-between align-items-center mb-4",
                },
                h.h4(
                    { class: "fw-bold mb-0" },
                    v(this.editingFeatureIndex, (i) =>
                        i.value === -1 ? "New Attribute" : "Edit Attribute",
                    ),
                ),
                h.button({
                    class: "btn-close",
                    listeners: { click: () => this.featureHolder.hide() },
                }),
            ),

            v(this.currentFeature, (feat) => {
                if (!feat.value) return null;

                return h.div(
                    h.div(
                        { class: "mb-4" },
                        h.label(
                            { class: "form-label fw-bold small text-muted" },
                            "ATTRIBUTE NAME",
                        ),
                        h.input({
                            class: "form-control bg-light border p-3 rounded-3",
                            placeholder: "e.g. Color or Size",
                            value: feat.value.name,
                            listeners: {
                                input: (e) => {
                                    feat.value.name = e.target.value;
                                },
                            },
                        }),
                        h.small(
                            { class: "text-muted d-block mt-1" },
                            "Example: Shirt Size, Laptop RAM, etc.",
                        ),
                    ),

                    // Choice Type
                    h.div(
                        { class: "mb-4" },
                        h.label(
                            { class: "form-label fw-bold small text-muted" },
                            "INPUT TYPE",
                        ),
                        h.select(
                            {
                                class: "form-select bg-light border p-3 rounded-3",
                                listeners: {
                                    change: (e) => {
                                        updateStateValue(feat, (value) => {
                                            value.choice_type = e.target.value;
                                            return value;
                                        });
                                    },
                                },
                            },
                            h.option(
                                {
                                    value: "single_choice",
                                },
                                either(
                                    feat.value.choice_type === "single_choice",
                                    {
                                        selected: true,
                                    },
                                ),
                                "Single Choice (Dropdown)",
                            ),
                            h.option(
                                {
                                    value: "multiple_choice",
                                },
                                either(
                                    feat.value.choice_type ===
                                        "multiple_choice",
                                    {
                                        selected: true,
                                    },
                                ),
                                "Multiple Choice (Checkboxes)",
                            ),
                            h.option(
                                { value: "text" },
                                either(feat.value.choice_type === "text", {
                                    selected: true,
                                }),
                                "Text Input (Custom message)",
                            ),
                            h.option(
                                { value: "number" },
                                either(feat.value.choice_type === "number", {
                                    selected: true,
                                }),
                                "Number Input",
                            ),
                        ),
                    ),

                    // Required Toggle
                    h.div(
                        { class: "mb-4 py-2 border-bottom border-top" },
                        this.renderToggleQuestionInForm(
                            "is_required",
                            "Required for Order?",
                            "Should customers be forced to choose this before buying?",
                        ),
                    ),

                    // Options (Only if Choice Type)
                    either(
                        ["single_choice", "multiple_choice"].includes(
                            feat.value.choice_type,
                        ),
                        () => [
                            h.div(
                                {
                                    class: "d-flex justify-content-between align-items-center mb-3",
                                },
                                h.h6({ class: "fw-bold mb-0" }, "Options"),

                                either(
                                    feat.value.choice_type === "single_choice",
                                    () =>
                                        h.div(
                                            { class: "form-check form-switch" },
                                            h.input(
                                                {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    role: "switch",
                                                    id: "price-toggle",
                                                    listeners: {
                                                        change: (e) => {
                                                            let current =
                                                                tool.deepCopy(
                                                                    feat.value,
                                                                );
                                                            current.has_different_prices =
                                                                e.target.checked;
                                                            feat.value =
                                                                current;
                                                        },
                                                    },
                                                },
                                                either(
                                                    feat.value
                                                        .has_different_prices,
                                                    {
                                                        checked: true,
                                                    },
                                                ),
                                            ),
                                            h.label(
                                                {
                                                    class: "form-check-label small text-muted",
                                                    for: "price-toggle",
                                                },
                                                "Custom Prices",
                                            ),
                                        ),
                                ),
                            ),
                            h.div(
                                { class: "d-grid gap-2 mb-4" },
                                ...feat.value.values.map((v, vi) =>
                                    h.div(
                                        { class: "d-flex gap-2" },
                                        h.FormField(
                                            {
                                                id: `feature-${vi}-input-option-value`,
                                                value: v.value,
                                                placeholder: "Label (e.g. Red)",
                                                label: {
                                                    value: "Label (e.g. Red)",
                                                },
                                                enterkeyhint: "next",
                                                listeners: {
                                                    input: (e) => {
                                                        let current =
                                                            tool.deepCopy(
                                                                feat.value,
                                                            );
                                                        current.values[
                                                            vi
                                                        ].value =
                                                            e.target.value;
                                                        feat.value = current;
                                                    },
                                                    keydown: (e) => {
                                                        if (e.key === "Enter") {
                                                            let current =
                                                                tool.deepCopy(
                                                                    feat.value,
                                                                );
                                                            current.values.push(
                                                                {
                                                                    value: "",
                                                                    price: "",
                                                                },
                                                            );
                                                            feat.value =
                                                                current;
                                                        }
                                                    },
                                                },
                                            },
                                            { $class: "flex-fill" },
                                        ),

                                        either(
                                            feat.value.has_different_prices,
                                            () =>
                                                h.input({
                                                    class: "form-control border",
                                                    style: "width: 60px;",
                                                    type: "number",
                                                    placeholder:
                                                        dc.userCurrency,
                                                    value: v.price,
                                                    listeners: {
                                                        input: (e) => {
                                                            let current =
                                                                tool.deepCopy(
                                                                    feat.value,
                                                                );
                                                            current.values[
                                                                vi
                                                            ].price =
                                                                e.target.value;
                                                            feat.value =
                                                                current;
                                                        },
                                                        keydown: (e) => {
                                                            if (
                                                                e.key ===
                                                                "Enter"
                                                            ) {
                                                                let current =
                                                                    tool.deepCopy(
                                                                        feat.value,
                                                                    );
                                                                current.values.push(
                                                                    {
                                                                        value: "",
                                                                        price: "",
                                                                    },
                                                                );
                                                                feat.value =
                                                                    current;
                                                            }
                                                        },
                                                    },
                                                }),
                                        ),
                                        h.button(
                                            {
                                                class: "btn text-danger p-0",
                                                listeners: {
                                                    click: () => {
                                                        let current =
                                                            tool.deepCopy(
                                                                feat.value,
                                                            );
                                                        current.values.splice(
                                                            vi,
                                                            1,
                                                        );
                                                        feat.value = current;
                                                    },
                                                },
                                            },
                                            h.i({ class: "bi bi-x-lg" }),
                                        ),
                                    ),
                                ),
                                h.button(
                                    {
                                        class: "btn btn-link text-decoration-none p-0 text-start small fw-bold",
                                        listeners: {
                                            click: () => {
                                                let current = tool.deepCopy(
                                                    feat.value,
                                                );
                                                current.values.push({
                                                    value: "",
                                                    price: "",
                                                });
                                                feat.value = current;
                                            },
                                        },
                                    },
                                    "+ Add Option",
                                ),
                            ),
                        ],
                        () =>
                            h.div(
                                { class: "mb-4" },
                                h.label(
                                    {
                                        class: "form-label fw-bold small text-muted",
                                    },
                                    "PLACEHOLDER",
                                ),
                                h.input({
                                    class: "form-control bg-light border p-3 rounded-3",
                                    placeholder: "e.g. Enter your name here",
                                    value: feat.value.values[0]?.value || "",
                                    listeners: {
                                        input: (e) => {
                                            if (!feat.value.values[0]) {
                                                feat.value.values[0] = {
                                                    value: "",
                                                    price: "",
                                                };
                                            }

                                            updateStateValue(feat, (value) => {
                                                value.values[0].value =
                                                    e.target.value;
                                                return value;
                                            });
                                        },
                                    },
                                }),
                                h.small(
                                    { class: "text-muted d-block mt-1" },
                                    "This text guides the customer on what to type.",
                                ),

                                // Number Input pricing (e.g. sold by weight: "for every
                                // 0.5, the price is 10" -> entering 3 costs 60)
                                either(
                                    feat.value.choice_type === "number",
                                    () => this.renderNumberPricingFields(feat),
                                ),
                            ),
                    ),

                    // Action
                    h.div(
                        { class: "mt-5" },
                        h.button(
                            {
                                class: "btn btn-primary w-100 rounded-pill py-3 fw-bold",
                                listeners: { click: () => this.saveFeature() },
                            },
                            "Confirm Attribute",
                        ),
                    ),
                );
            }),
        );
    }

    // --- Number Input Pricing (interval + price-per-interval) ---
    // e.g. a product sold by weight: "for every 0.5[kg], the price is 10"
    // -> a customer entering 3 would pay (3 / 0.5) * 10 = 60.
    renderNumberPricingFields(feat) {
        return h.div(
            { class: "mt-4 pt-3 border-top" },
            h.div(
                {
                    class: "d-flex justify-content-between align-items-center mb-3",
                },
                h.h6({ class: "fw-bold mb-0" }, "Affects Price"),
                h.div(
                    { class: "form-check form-switch" },
                    h.input(
                        {
                            class: "form-check-input",
                            type: "checkbox",
                            role: "switch",
                            id: "number-price-toggle",
                            listeners: {
                                change: (e) => {
                                    let current = tool.deepCopy(feat.value);
                                    current.has_different_prices = e.target.checked;
                                    feat.value = current;
                                },
                            },
                        },
                        either(feat.value.has_different_prices, {
                            checked: true,
                        }),
                    ),
                    h.label(
                        {
                            class: "form-check-label small text-muted",
                            for: "number-price-toggle",
                        },
                        "Custom Price",
                    ),
                ),
            ),

            either(feat.value.has_different_prices, () => [
                h.div(
                    { class: "d-flex gap-2 mb-2" },
                    h.div(
                        { class: "flex-fill" },
                        h.label(
                            { class: "form-label small text-muted mb-1" },
                            "FOR EVERY",
                        ),
                        h.input({
                            class: "form-control bg-light border p-3 rounded-3",
                            type: "number",
                            min: "0",
                            step: "any",
                            placeholder: "e.g. 0.5",
                            value: feat.value.price_interval ?? "",
                            listeners: {
                                input: (e) => {
                                    let current = tool.deepCopy(feat.value);
                                    current.price_interval = e.target.value;
                                    feat.value = current;
                                },
                            },
                        }),
                    ),
                    h.div(
                        { class: "flex-fill" },
                        h.label(
                            { class: "form-label small text-muted mb-1" },
                            `PRICE (${dc.userCurrency})`,
                        ),
                        h.input({
                            class: "form-control bg-light border p-3 rounded-3",
                            type: "number",
                            min: "0",
                            step: "any",
                            placeholder: "e.g. 10",
                            value: feat.value.price_per_interval ?? "",
                            listeners: {
                                input: (e) => {
                                    let current = tool.deepCopy(feat.value);
                                    current.price_per_interval = e.target.value;
                                    feat.value = current;
                                },
                            },
                        }),
                    ),
                ),
                h.small(
                    { class: "text-muted d-block" },
                    "Example: for every 0.5, the price is 10 — a customer entering 3 would pay 60.",
                ),
            ]),
        );
    }

    renderToggleQuestionInForm(key, question, help) {
        return h.div(
            {
                class: "d-flex justify-content-between align-items-center gap-3",
            },
            h.div(
                { class: "flex-fill" },
                h.h6({ class: "fw-bold mb-0 small" }, question),
                h.p(
                    {
                        class: "text-muted small mb-0",
                        style: "font-size: 0.75rem;",
                    },
                    help,
                ),
            ),
            h.div(
                { class: "btn-group p-1 bg-light rounded-pill" },
                v(this.currentFeature, (feat) =>
                    h.button(
                        {
                            class: `btn btn-xs rounded-pill py-1 px-3 fw-bold ${
                                !feat[key]
                                    ? "bg-danger-subtle text-danger"
                                    : "bg-transparent text-muted border-0"
                            }`,
                            listeners: {
                                click: () => {
                                    let c = tool.deepCopy(feat.value);
                                    c[key] = false;
                                    feat.value = c;
                                },
                            },
                        },
                        "No",
                    ),
                ),
                v(this.currentFeature, (feat) =>
                    h.button(
                        {
                            class: `btn btn-xs rounded-pill py-1 px-3 fw-bold ${
                                feat[key]
                                    ? "bg-success-subtle text-success"
                                    : "bg-transparent text-muted border-0"
                            }`,
                            listeners: {
                                click: () => {
                                    let c = tool.deepCopy(feat.value);
                                    c[key] = true;
                                    feat.value = c;
                                },
                            },
                        },
                        "Yes",
                    ),
                ),
            ),
        );
    }

    saveFeature() {
        const feat = this.currentFeature.value;
        if (!feat.name)
            return inform("Please enter an attribute name", "warning");

        if (
            feat.choice_type === "number" &&
            feat.has_different_prices &&
            (!(parseFloat(feat.price_interval) > 0) ||
                !(parseFloat(feat.price_per_interval) > 0))
        ) {
            return inform(
                "Please enter a valid interval and price greater than 0",
                "warning",
            );
        }

        const index = this.editingFeatureIndex.value;
        let current = this.features.value;
        current ??= [];

        if (index === -1) {
            current.push(feat);
        } else {
            current[index] = feat;
        }

        this.features.value = current;

        this.featureHolder.hide();
    }

    handleProductSearch(e) {
        const q = e.target.value.trim();
        if (this.productSearchTimeout) clearTimeout(this.productSearchTimeout);
        if (q.length < 2) {
            this.productSuggestions.value = [];
            this.showProductSuggestions.value = false;
            return;
        }
        this.productSearchTimeout = setTimeout(
            () => this.fetchProductSuggestions(q),
            300,
        );
    }

    async fetchProductSuggestions(query) {
        this.loadingProductSuggestions.value = true;
        this.showProductSuggestions.value = true;
        try {
            const res = await api.get(
                `companies/${this.formData.company_id}/products/search`,
                { q: query },
            );
            if (res) this.productSuggestions.value = res.data.result.data || [];
        } catch (e) {
            consoleErrorOnLocal(e);
        } finally {
            this.loadingProductSuggestions.value = false;
        }
    }

    addExtraProduct(prod, input = null) {
        const exists = this.extras.value.find((e) => e.buyable_id === prod.id);
        if (exists) {
            exists.quantity++;
            updateStateValue(this.extras, (v) => v);
        } else {
            updateStateValue(this.extras, (v) => {
                v.push({
                    buyable_id: prod.id,
                    buyable_type: "App\\Models\\Product",
                    quantity: 1,
                    name: prod.name,
                    price: prod.selling_price,
                    thumbnail_path: prod.thumbnail_path,
                });
                return v;
            });
        }
        this.showProductSuggestions.value = false;
        if (input) input.value = "";
    }

    renderFeatureItem(feature, index) {
        return h.div(
            {
                class: "card border-0 shadow-none bg-light p-4",
                style: "border-radius: 16px;",
            },
            h.div(
                { class: "d-flex justify-content-between align-items-start" },
                h.div(
                    { class: "flex-fill" },
                    h.h6({ class: "fw-bold mb-1" }, feature.name),
                    h.div(
                        { class: "text-muted small" },
                        h.span(
                            { class: "badge bg-white text-dark border me-2" },
                            feature.choice_type.replace("_", " "),
                        ),
                        either(
                            feature.is_required,
                            () => h.span({ class: "text-danger" }, "Required"),
                            () => "Optional",
                        ),
                    ),
                    either(
                        feature.values.length > 0 &&
                            ["single_choice", "multiple_choice"].includes(
                                feature.choice_type,
                            ),
                        () =>
                            h.div(
                                { class: "mt-3 d-flex flex-wrap gap-2" },
                                ...feature.values.map((v) =>
                                    h.span(
                                        {
                                            class: "badge bg-white text-primary border rounded-pill",
                                        },
                                        v.value,
                                        either(
                                            feature.has_different_prices &&
                                                v.price,
                                            () =>
                                                h.span(
                                                    {
                                                        class: "ms-1 text-muted fw-normal",
                                                    },
                                                    ` @ ${dc.userCurrency} ${v.price}`,
                                                ),
                                        ),
                                    ),
                                ),
                            ),
                    ),
                    either(
                        ["text", "number"].includes(feature.choice_type),
                        () =>
                            h.div(
                                { class: "mt-2 small text-muted italic" },
                                "Placeholder: ",
                                feature.values[0]?.value || "none",
                            ),
                    ),
                    either(
                        feature.choice_type === "number" &&
                            feature.has_different_prices,
                        () =>
                            h.div(
                                { class: "mt-1 small text-muted" },
                                "Rate: ",
                                h.span(
                                    { class: "fw-bold text-primary" },
                                    `Every ${feature.price_interval} = ${dc.userCurrency} ${feature.price_per_interval}`,
                                ),
                            ),
                    ),
                ),
                h.div(
                    { class: "d-flex gap-2" },
                    h.button(
                        {
                            class: "btn btn-white btn-sm rounded-circle border shadow-sm",
                            listeners: {
                                click: () => this.openFeatureForm(index),
                            },
                        },
                        h.i({ class: "bi bi-pencil" }),
                    ),
                    h.button(
                        {
                            class: "btn btn-white btn-sm rounded-circle border shadow-sm text-danger",
                            listeners: {
                                click: () => {
                                    let current = this.features.value;
                                    current.splice(index, 1);
                                    this.features.value = current;
                                },
                            },
                        },
                        h.i({ class: "bi bi-trash" }),
                    ),
                ),
            ),
        );
    }

    renderExtraItem(extra, index) {
        return h.div(
            {
                class: "card border-0 shadow-none bg-light p-4 mb-3",
                style: "border-radius: 20px;",
            },
            h.div(
                { class: "d-flex align-items-start gap-3 mb-4" },
                h.img({
                    src:
                        extra.thumbnail_path ||
                        "/assets/images/product-placeholder.png",
                    class: "rounded-4 shadow-sm",
                    style: "width: 64px; height: 64px; object-fit: cover;",
                }),
                h.div(
                    { class: "flex-fill" },
                    h.div({ class: "fw-bold fs-5 text-dark" }, extra.name),
                    h.div(
                        { class: "text-muted small" },
                        `Original Price: ${dc.userCurrency} ${extra.price}`,
                    ),
                ),
                h.button(
                    {
                        class: "btn btn-white btn-sm rounded-circle border shadow-sm text-danger",
                        listeners: {
                            click: () => {
                                updateStateValue(this.extras, (v) => {
                                    v.splice(index, 1);
                                    return v;
                                });
                            },
                        },
                    },
                    h.i({ class: "bi bi-trash" }),
                ),
            ),

            h.div(
                { class: "row g-4" },
                // Price Field
                h.div(
                    { class: "col-md-6" },
                    h.label(
                        {
                            class: "form-label fw-bold small text-muted text-uppercase mb-2",
                        },
                        "Selling Price",
                    ),
                    h.div(
                        { class: "input-group input-group-lg" },
                        h.span(
                            {
                                class: "input-group-text bg-white border-end-0 text-muted",
                            },
                            dc.userCurrency,
                        ),
                        h.input({
                            class: "form-control border-start-0 bg-white ps-0",
                            type: "number",
                            value: extra.price,
                            disabled: true,
                            listeners: {
                                input: (e) => {
                                    extra.price = e.target.value;
                                    updateStateValue(this.extras, (v) => {
                                        v[index] = extra;
                                        return v;
                                    });
                                },
                            },
                        }),
                    ),
                    h.small(
                        { class: "text-muted mt-2 d-block" },
                        "Set how much this extra costs when added to this product.",
                    ),
                ),

                // Quantity Field
                h.div(
                    { class: "col-md-6" },
                    h.label(
                        {
                            class: "form-label fw-bold small text-muted text-uppercase mb-2",
                        },
                        "Quantity",
                    ),
                    h.div(
                        { class: "d-flex align-items-center gap-2" },
                        h.input({
                            class: "form-control form-control-lg text-center bg-white border fw-bold flex-fill",
                            style: "width: 80px;",
                            type: "number",
                            value: extra.quantity,
                            disabled: true,
                            listeners: {
                                input: (e) => {
                                    extra.quantity = Math.max(
                                        1,
                                        parseInt(e.target.value) || 1,
                                    );
                                    updateStateValue(this.extras, (v) => {
                                        v[index] = extra;
                                        return v;
                                    });
                                },
                            },
                        }),
                    ),
                    h.small(
                        { class: "text-muted mt-2 d-block" },
                        "How many of this item is included as an extra?",
                    ),
                ),
            ),
        );
    }

    async fetchBranches() {
        this.loadingBranches.value = true;
        try {
            const res = await api.get(
                `companies/${this.formData.company_id}/branches`,
            );
            if (res) this.branches.value = res.data.branches;
        } catch (e) {
            consoleErrorOnLocal(e);
        } finally {
            this.loadingBranches.value = false;
        }
    }

    toggleBranch(id) {
        updateStateValue(this.selectedBranches, (v) => {
            if (v.includes(id)) return v.filter((bid) => bid !== id);
            v.push(id);
            return v;
        });
    }

    triggerUpload(id) {
        document.getElementById(id).click();
    }

    handleImageUpload(e, type) {
        const files = e.target.files;
        if (!files.length) return;
        const handleFile = (file) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const src = reader.result;
                const options = new tool.ModalOptions();
                options.buttons.right.text = "Crop & Confirm";
                options.classes.buttons.right = "btn btn-primary rounded-pill";
                options.staticBackdrop();
                const { buttons, modal } = tool.modal(
                    "Crop Image",
                    h.EditProductImageForm(src),
                    options,
                );
                modal.element.addEventListener("shown.bs.modal", () => {
                    const preview = dom.id("epif-image-view");
                    this.cropper.obj = new Cropper(preview, {
                        aspectRatio: 16 / 9,
                        viewMode: 2,
                    });
                });
                buttons.right.button.addEventListener("click", () => {
                    const cropped = this.cropper.obj
                        .getCroppedCanvas()
                        .toDataURL();
                    if (type === "thumbnail")
                        this.thumbnail.value = {
                            cropped,
                            isExisting: false,
                            original: src,
                        };
                    else
                        updateStateValue(this.previewImages, (v) => {
                            v.push({
                                cropped,
                                isExisting: false,
                                original: src,
                            });
                            return v;
                        });
                    modal.close();
                });
            };
        };
        if (type === "thumbnail") handleFile(files[0]);
        else Array.from(files).forEach((f) => handleFile(f));
    }
}

ojs(EditProduct);
